<template>
  <div class="guide">
    <img :src="headimg" alt="">
    <div class="guide-title">
      <div>{{title}}</div>
      <img :src="enimg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "DrugGuide",
  props: {
    title: {
      type: String,
      default: ""
    },
    headimg: {
      type: String,
      default: ""
    },
    enimg: {
      type: String,
      default: ""
    }
  }
}
</script>

<style lang="scss" scoped>
.guide {
  width: 100%;
  // height: 365px;
  overflow: hidden;
  position: relative;
  color: #fff;
  &>img {
    width: 100%;
    display: block;
  }
  .guide-title {
    position: absolute;
    width: 230px;
    left: 0;
    right: 0;
    top: 165px;
    bottom: 105px;
    margin: auto;
    z-index: 50;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    font-size: 42px;
    font-family: "PingFang SC-Medium", "PingFang SC";
    img {
      width: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/DrugGuide.vue